import React from 'react';
import { galleryShots } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="gallery" className="w-full bg-white py-20 lg:py-28" data-id="element-109" data-mp="3ic7r1094jarw">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-110" data-mp="3ibg6qlkz8zgx">
        <div className="max-w-2xl" data-id="element-111" data-mp="3dcv5qjxwibrf">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-112" data-mp="3ddxw8qrbac6t">
            {t.gallery.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-113" data-mp="2kozaljnzcrwr">
            {t.gallery.intro}
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2" data-id="element-114" data-mp="2ze56axnlzzzw">
          {galleryShots.map((shot, index) => <li key={shot.src} className={`group relative overflow-hidden rounded-lg bg-neutral-100 ${shot.featured ? 'lg:col-span-2 lg:row-span-2' : ''}`} data-id="element-115" data-mp="2uktyouaz3f6x" data-mpi={index}>
              <img src={shot.src} alt={shot.alt} loading="lazy" className="h-64 w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] lg:h-full" data-id="element-116" data-mp="rd2saohf76s6" />
              <div className="absolute inset-x-0 bottom-0 bg-forest-deep/85 px-5 py-3" data-id="element-117" data-mp="114gyff3vn4ua">
                <span className="font-display text-sm font-bold text-white" data-id="element-118" data-mp="1536ejfgav0hm">
                  {t.gallery.captions[index]}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}